import { Injectable } from "@angular/core";
import { Constructor } from "@skylab-shared/types";
import { Observable, Subject } from "rxjs";

export type RootContainerOverlayOptions = {
    text?: string,
    spinner?: boolean;
    component?: Constructor<unknown>
};

@Injectable({
    providedIn: 'root'
})
export class RootContainerOverlayService {
    private visibilityStatusSubject$ = new Subject<RootContainerOverlayOptions | null>();

    private readonly defaults: RootContainerOverlayOptions = {
        text: '',
        spinner: true,
        component: undefined
    };

    public show(options?: RootContainerOverlayOptions): void {
        const opts = options ? { ...this.defaults, ...options } : this.defaults;
        this.visibilityStatusSubject$.next(opts);
    };

    public hide(): void {
        this.visibilityStatusSubject$.next(null);
    };

    public get visibilityStatus$(): Observable<RootContainerOverlayOptions | null> {
        return this.visibilityStatusSubject$.asObservable();
    }
}
